exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width:600px){.h5-components .footer-box{height:40px;line-height:20px;padding:10px 0;font-size:12px;text-align:center}.h5-components .footer-box .footer-logo{display:none}.h5-components .footer-box .footer-space{margin:0 5px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-886d17be","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/common/e-footer.vue
// module id = 682
// module chunks = 0